//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/Builder.js";
import "../Annotations/Annotations.AssociatedObjectsBuilder.js";
import "../Annotations/Annotations.LeaderBuilder.js";
import "../Annotations/Annotations.OriginBuilder.js";
import "../Annotations/Annotations.StyleBuilder.js";
let d=[[[1,"AssociatedObjects",0,"Annotations.AssociatedObjectsBuilder",0],[0,"Attribute",1,"Annotations.Pmi",0],[0,"BusinessModifier",1,"NXObject",0],[0,"KnowledgeFusionClassName",1,0],[1,"Leader",0,"Annotations.LeaderBuilder",0],[1,"Origin",0,"Annotations.OriginBuilder",0],[1,"Style",0,"Annotations.StyleBuilder",0]],[[["nAttributeValues"],"GetAttributeValues",{R_:{attributeValues:"NXObject[]"}},0,0],[["attributeValues"],"SetAttributeValues",{},1,0]],[]];
SPLM.Annotations.PmiAttributeBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.PmiAttributeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;